export default __webpack_public_path__ + "static/media/team-illustration-2.76aa0427.svg";